import { render, staticRenderFns } from "./TransProgramLowIncomeInd.vue?vue&type=template&id=0946dce2"
import script from "./TransProgramLowIncomeInd.vue?vue&type=script&lang=ts"
export * from "./TransProgramLowIncomeInd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports